'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  width: 100%;\n  margin-bottom: 10px;\n  display: flex;\n  align-items: flex-end;\n  justify-content: space-between;\n'], ['\n  width: 100%;\n  margin-bottom: 10px;\n  display: flex;\n  align-items: flex-end;\n  justify-content: space-between;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  font-size: 12px;\n  color: ', ';\n  margin-top: 3px;\n'], ['\n  font-size: 12px;\n  color: ', ';\n  margin-top: 3px;\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  display: flex;\n  align-items: flex-end;\n  justify-content: space-between;\n'], ['\n  display: flex;\n  align-items: flex-end;\n  justify-content: space-between;\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  margin-left: 20px;\n'], ['\n  margin-left: 20px;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _colors = require('../../../libs/colors');

var _Heading = require('../../Heading/Heading');

var _Heading2 = _interopRequireDefault(_Heading);

var _InputTyping = require('../../InputTyping/InputTyping');

var _InputTyping2 = _interopRequireDefault(_InputTyping);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
} // Colors
// Components


var Container = _styledComponents2.default.div(_templateObject);

var Subtitle = _styledComponents2.default.div(_templateObject2, _colors.darkGrey);

var Right = _styledComponents2.default.div(_templateObject3);

var RightItem = _styledComponents2.default.div(_templateObject4);

var Header = function Header(_ref) {
  var title = _ref.title,
      subtitle = _ref.subtitle,
      search = _ref.search,
      onSearch = _ref.onSearch,
      items = _ref.items;
  var rightItems = items(RightItem);
  return !title && !subtitle && !onSearch && (!rightItems || !rightItems.length) ? null : _react2.default.createElement(Container, null, _react2.default.createElement('div', null, title !== null && _react2.default.createElement(_Heading2.default, {
    size: '2'
  }, title), subtitle !== null && _react2.default.createElement(Subtitle, null, subtitle)), _react2.default.createElement(Right, null, rightItems, onSearch !== null && _react2.default.createElement(RightItem, null, _react2.default.createElement(_InputTyping2.default, {
    value: search,
    onChange: onSearch,
    preIcon: 'search1',
    placeholder: 'Search'
  }))));
};

Header.propTypes = {
  title: _propTypes2.default.string,
  subtitle: _propTypes2.default.string,
  search: _propTypes2.default.string,
  onSearch: _propTypes2.default.func,
  items: _propTypes2.default.func
};
exports.default = Header;